module.exports = __webpack_public_path__ + "static/media/Falcon901_2c.960c2fa0.svg";